<template>
    <div class="container-ths">
        <AuthHeader />
        <div class="container is-centered sign-in">
            <SignInForm 
                :mode="routerName"
                :button-title="$t('register')"
                :header-title="$t('create_account')"/>
        </div>
    </div>
</template>

<script>
    import SignInForm from '@/components/SignInForm.vue'
    import AuthHeader from '@/components/AuthHeader.vue'

    export default {
        name: "SignUp",
        components: {SignInForm, AuthHeader},
        computed: {
            routerName() {
                return this.$route.name;
            }
        }
    }
</script>

<style scoped>

</style>
